module.exports = __webpack_public_path__ + "static/img/avatar_comment@3x.d822bfaa.png";